import { forIn } from 'lodash';

export const getUsersByIDsTransformer = (data) => {
    const transformedPayload = {};
    try {
        const payload = JSON.parse(data);
        forIn(payload.Users, (user, userID) => {
            if (user.Found) {
                transformedPayload[userID] = {
                    id: userID,
                    firstName: user.FirstName,
                    lastName: user.LastName,
                    clockedIn: false, // default to false until contacts are searched on
                    active: user.Active,
                };
            }
        });
        return transformedPayload;
    } catch (error) {
        // swallow and return the payload as-is so axios can handle it.
    }
    return data;
};
